import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./reducers/authReducer";
import staffReducer from "./reducers/staffReducer";
import maintainedReducer from "./reducers/maintainedBoatsReducer";
import servicePresetsReducer from "./reducers/servicePresetsReducer";
import tourReducer from "./reducers/tourReducer";

const TOUR_STORAGE_KEY = "fm_tour_state_v1";
const TOOLTIP_SEEN_STORAGE_KEY = "fm_tooltip_seen_v1";

const loadTourState = () => {
    try {
        if (typeof window === "undefined" || !window.sessionStorage) return undefined;
        const raw = window.sessionStorage.getItem(TOUR_STORAGE_KEY);
        if (!raw) return undefined;
        const parsed = JSON.parse(raw);
        if (
            parsed &&
            typeof parsed === "object" &&
            typeof parsed.active === "boolean" &&
            typeof parsed.step === "number"
        ) {
            return { active: parsed.active, step: parsed.step };
        }
        return undefined;
    } catch (_e) {
        return undefined;
    }
};

const store = configureStore({
    reducer: {
        authReducer,
        staffReducer,
        maintainedReducer,
        servicePresetsReducer,
        tourReducer,
    },
    preloadedState: {
        tourReducer: loadTourState(),
    },
});

store.subscribe(() => {
    try {
        if (typeof window === "undefined" || !window.sessionStorage) return;
        const tourState = store.getState()?.tourReducer;
        if (!tourState) return;
        window.sessionStorage.setItem(
            TOUR_STORAGE_KEY,
            JSON.stringify({ active: !!tourState.active, step: Number(tourState.step) || 0 }),
        );

        const tooltipSeen = store.getState()?.authReducer?.tooltipSeen;
        if (typeof tooltipSeen === "boolean") {
            window.sessionStorage.setItem(TOOLTIP_SEEN_STORAGE_KEY, tooltipSeen ? "true" : "false");
        }
    } catch (_e) {
        // ignore storage errors
    }
});

export default store;
